//2.0アップグレード時にアイコンが表示されなかったので追加。要：npm install @mdi/font -D
import '@mdi/font/css/materialdesignicons.css' 

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/styles/main.sass'
//日本語化
import ja from 'vuetify/es5/locale/ja.js'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    lang: {
      locales: {ja},
      current: 'ja'
    },    
  },
});